import { useMutation, useQueryClient } from '@tanstack/react-query';
import tourBudgetApi from '@/features/dashboard/tourBudget/api/tourBudgetApi.ts';
import { tourBudgetApiQueryKeys } from '@/features/dashboard/tourBudget/api/tourBudgetApi.queryKeys.ts';
import { SetTourBudgetRequestDto } from '@/features/dashboard/tourBudget/types/TourBudgetRequest.ts';
import { tourDashboardApiQueryKeys } from '@/features/dashboard/tours/api/tourDashboardApi.queryKeys.ts';
import { invalidateAttentionQueries } from '@/utils/invalidateAttentionQueries.ts';
import { toast } from 'sonner';

export default function useSetTourBudget(tourId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: SetTourBudgetRequestDto) =>
      tourBudgetApi.setBudget(tourId, dto),
    onSuccess: (data) => {
      queryClient.setQueryData(tourBudgetApiQueryKeys.byTourId(tourId), data);
      queryClient.invalidateQueries({
        queryKey: tourDashboardApiQueryKeys.finance(tourId),
      });
      void invalidateAttentionQueries(queryClient, tourId);
      toast.success('Budżet został zapisany');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas zapisywania budżetu.',
      });
    },
  });
}
